import { inject } from '@angular/core';
import { CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthTokenService } from '../../infrastructure/services/auth-token.service';

export const authGuard: CanActivateFn = (_route, state: RouterStateSnapshot) => {
  const tokenService = inject(AuthTokenService);
  const router = inject(Router);

  if (!tokenService.isAuthenticated()) {
    const returnUrl = state.url === '/dashboard' ? undefined : state.url;
    return router.createUrlTree(['/login'], { queryParams: returnUrl ? { returnUrl } : {} });
  }

  const isTemporalPassword = tokenService.currentUser()?.isTemporalPassword ?? false;
  const isChangingPassword = state.url.startsWith('/change-temporal-password');

  if (isTemporalPassword && !isChangingPassword) {
    return router.createUrlTree(['/change-temporal-password']);
  }

  return true;
};

export const publicGuard: CanActivateFn = () => {
  const tokenService = inject(AuthTokenService);
  const router = inject(Router);

  if (!tokenService.isAuthenticated()) {
    return true;
  }

  return router.createUrlTree(['/orders']);
};
